import { RoundImage } from '@fable/components'
import { css, cx } from '@fable/theme'
import { ClubModeratorIcon } from './ClubModeratorIcon'
import { usePreloadImage } from '@fable/hooks'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  image?: string
  altTag?: string
  hasIcon?: boolean
  iconAlign?: 'left' | 'right'
}

export const ClubModeratorAvatar = ({
  className = '',
  image,
  altTag,
  hasIcon = false,
  iconAlign = 'left',
  ...props
}: Props) => {
  const avatar = usePreloadImage(image || '', 200)

  return (
    <div
      data-testid="club-moderator-avatar"
      className={cx(
        css`
          position: relative;
          width: 48px;
          height: 48px;
        `,
        className
      )}
      {...props}
    >
      <RoundImage
        src={avatar?.src || ''}
        alt={`${altTag} avatar`}
        size={140}
        diameter="48px"
      />
      {hasIcon ? (
        <ClubModeratorIcon
          data-testid="club-moderator-icon"
          className={cx(
            css`
              position: absolute;
              bottom: 0;
              z-index: 10;
            `,
            iconAlign === 'right'
              ? css`
                  right: 0;
                `
              : css`
                  left: 0;
                `
          )}
        />
      ) : null}
    </div>
  )
}
